module.exports = __webpack_public_path__ + "img/home-line3-img2.632f5c74.png";